// extracted by mini-css-extract-plugin
export default {"table-container":"j8fcp","document-discount-datatable":"UHDIb","p-datatable-tbody":"zpXBr","p-datatable-thead":"_r7RV","actionButtons":"amnVJ","table-header":"HVCgB"};